var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var TramosFilter = /** @class */ (function (_super) {
    __extends(TramosFilter, _super);
    function TramosFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.SomId = null;
        _this.descripcio = '';
        _this.numPlazas = null;
        _this.temporadaSomId = null;
        _this.labels['SomId'] = _this.i18n('Id');
        _this.labels['descripcio'] = _this.i18n('Descripció');
        _this.labels['numPlazas'] = _this.i18n('numPlazas');
        _this.labels['temporadaSomId'] = _this.i18n('temporada');
        return _this;
    }
    return TramosFilter;
}(FilterData));
export { TramosFilter };
